// Omertàbella — global footer (used on every page).
// Renders the "running line" + wax-seal monogram + copyright row.
import { Link } from "react-router-dom";
import { LogoLockup } from "./LogoLockup";

const WAX_SEAL_FILTER =
  "drop-shadow(0 0 12px rgba(201,168,76,0.18)) drop-shadow(0 1px 1px rgba(0,0,0,0.5))";

export function BrandFooter() {
  return (
    <footer
      data-testid="brand-footer"
      className="relative border-t border-brand-text/[0.07]"
    >
      <div className="mx-auto flex max-w-7xl flex-col items-center gap-6 px-6 py-12 sm:px-10">
        {/* Running line */}
        <div className="flex flex-col items-center gap-3">
          <span
            aria-hidden
            className="block h-px"
            style={{ width: 60, backgroundColor: "rgba(201,168,76,0.15)" }}
          />
          <p
            data-testid="footer-running-line"
            className="select-none text-center"
            style={{
              fontFamily: "Inter, system-ui, sans-serif",
              fontWeight: 400,
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: "0.25em",
              color: "rgba(245,240,232,0.4)",
            }}
          >
            Roster names withheld. Strategy proprietary. Outcomes private.
          </p>
        </div>

        {/* Wax-seal monogram + copyright row */}
        <div className="mt-2 flex w-full flex-col items-center gap-6 sm:flex-row sm:justify-between">
          <span
            data-testid="footer-wax-seal"
            style={{ filter: WAX_SEAL_FILTER, display: "inline-flex" }}
          >
            <LogoLockup variant="footer" as={Link} to="/" />
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.32em] text-brand-text/35">
            © 2025 Omertàbella · Atlanta, GA
          </span>
        </div>
      </div>
    </footer>
  );
}
